import React from 'react'
import { Flex, Box } from 'reflexbox/styled-components'
import styled from 'styled-components'
import { Link } from 'gatsby'

export default () => {
  return (
    <Flex flex={1} pt={[3, '95px']}>
      <Box width={[0, `${(2 / 10) * 100}%`]} pb={[3, 0]} px={[0, 3]} />
      <Box width={[1, `${(8 / 10) * 100}%`]} px={[2, 3]}>
        <PageTitle>
          We start with the
          <br /> details that matter
          <br />
          to you. <Link to="/contact">Let&rsquo;s talk</Link>
        </PageTitle>
      </Box>
    </Flex>
  )
}

const PageTitle = styled.h1`
  margin: 0px;
  font-size: 80px;
  letter-spacing: -0.005em;
  line-height: 110%;
  position: relative;
  left: -5px;
  @media screen and (max-width: 1370px) {
    font-size: 6.6vw;
    letter-spacing: -0.005em;
    left: -2px;
  }
  @media screen and (max-width: 900px) {
    font-size: 10.5vw;
    line-height: 118%;
    letter-spacing: -0.01em;
    left: -2px;
  }
  font-weight: normal;
  color: ${(props) => props.theme.pageTheme.headingSecondary};
  a {
    text-decoration: none;
    color: ${(props) => props.theme.pageTheme.fgSecondary};
    border-bottom: 3px solid ${(props) => props.theme.pageTheme.fgSecondary};
    &:hover {
      color: ${(props) => props.theme.pageTheme.accentSecondary};
      border-bottom: 3px solid
        ${(props) => props.theme.pageTheme.accentSecondary};
    }
  }
  @media (max-width: 992px) {
  }
`
